var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMenuExpandIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 3H12H21V21H3V3ZM4.5 4.5V19.5H10.5V4.5H4.5ZM12 19.5H19.5V4.5H12V19.5ZM5.87012 10.5302L6.93012 9.47021L9.46012 12.0002L6.93012 14.5302L5.87012 13.4702L7.34012 12.0002L5.87012 10.5302Z",
    fill: "#161616"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMenuExpandIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Menu_Expand_Icon.e7629e8dd4c6f4a2a4073706ef0e2606.svg";